import { CountryCode, NationalNumber, isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';

interface ParsePhoneNumberProps {
    defaultCountryCode: CountryCode;
    phoneNumber?: string;
}

interface ParsedPhoneNumber {
    nationalNumber: NationalNumber;
    country: CountryCode;
}

/**
 * Parses phone number and country code for the phone input component default values. User can still change the country code and phone number manually.
 * @param defaultCountryCode - The default country code to use if no country code is found in the phone number
 * @param phoneNumber - The phone number
 * @example
 * defaultCountryCode = 'NO'
 * phoneNumber = '+4670123456' or '070123456' or '70123456'
 * @returns { countryCode, nationalNumber }
 * @example
 * countryCode = 'NO' used for userCountry
 * nationalNumber = '70123456' used for defaultValue
 */

const parsePhoneNumberForPhoneInput = ({ defaultCountryCode, phoneNumber }: ParsePhoneNumberProps) => {
    let nationalNumber: NationalNumber = ''; // example: 70123456
    let countryCode: CountryCode = defaultCountryCode; // example: NO

    // Example: +4670123456. O70123456 and 70123456 is not valid phone numbers for parsePhoneNumberFromString function
    if (typeof phoneNumber === 'string' && isValidPhoneNumber(phoneNumber)) {
        const parsedPhoneNumberObject = parsePhoneNumberFromString(String(phoneNumber)) as unknown as ParsedPhoneNumber;

        // Update nationalNumber if the user has a national number in their phone number
        nationalNumber = parsedPhoneNumberObject?.nationalNumber;

        // Update countryCode if the user has a country code in their phone number
        countryCode = parsedPhoneNumberObject?.country;
    } else if (typeof phoneNumber === 'string' && phoneNumber.startsWith('0')) {
        // Example: 070123456
        nationalNumber = phoneNumber.slice(1) || '';
    } else if (typeof phoneNumber === 'string') {
        // Example: 70123456
        nationalNumber = phoneNumber || '';
    }

    return { countryCode, nationalNumber };
};

export default parsePhoneNumberForPhoneInput;
